import { SearchOutlined } from "@ant-design/icons";
import { Input, Select } from "antd";

interface OrganizationsFiltersProps {
	onSearchChange: (value: string) => void;
	onStatusChange: (value: OrganizationStatusFilter) => void;
	searchValue: string;
	statusValue: OrganizationStatusFilter;
}

export type OrganizationStatusFilter = "active" | "all" | "disabled";

const statusOptions: Array<{ label: string; value: OrganizationStatusFilter }> = [
	{ label: "Barchasi", value: "all" },
	{ label: "Faol", value: "active" },
	{ label: "To'xtatilgan", value: "disabled" },
];

export function OrganizationsFilters({
	onSearchChange,
	onStatusChange,
	searchValue,
	statusValue,
}: OrganizationsFiltersProps) {
	return (
		<div className="crm-card crm-org-filters">
			<div className="crm-card-body">
				<Input
					className="crm-org-search"
					onChange={(event) => onSearchChange(event.target.value)}
					prefix={<SearchOutlined />}
					placeholder="Nom yoki kod bo'yicha qidirish"
					value={searchValue}
				/>
				<Select onChange={onStatusChange} options={statusOptions} value={statusValue} />
			</div>
		</div>
	);
}
